export default {
  groupSystemInfoSetting_00001: "",
};
